import { call, put, takeLatest } from "redux-saga/effects";
import { ManagerHashtagDetailReportAction } from "../../../actions";
import * as types from "../../../actions/actionTypes";
import moment from "jalali-moment";
import * as hashtagDetailReportApi from "../../../api/hashtagReport/detail/managerHashtagDetailReport";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../../../assets/checkErrorMessagesExist";
import { GetFilterDetail } from "../../../hocs/hashtagsReport/components/filter/tools";

moment.locale("fa");
export function* managerWatcherHashtagDetailReport() {
  yield takeLatest(types.MANAGER_GET_HASHTAG_DETAIL_REVIEW_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";

  return hashtagDetailReportApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerHashtagDetailReportAction.getSuccess(response.data));
  } catch (error) {
    // dispatch a failure action to the store with the error
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });

    yield put(ManagerHashtagDetailReportAction.getFailure(error));
  }
}
